import { render, staticRenderFns } from "./global_select_criteria.vue?vue&type=template&id=2d543cc1&scoped=true"
import script from "./global_select_criteria.vue?vue&type=script&lang=ts&setup=true"
export * from "./global_select_criteria.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./global_select_criteria.vue?vue&type=style&index=0&id=2d543cc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d543cc1",
  null
  
)

export default component.exports